import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import {
    useForm,
    useAuth,
    useFetch,
    useResource,
    useGrid,
    useModal,
    useStore,
    useToast,
    usePopup,
    TFormSchema,
    TGridSchema,
    usePage,
} from "@/comn/hooks"; // hook

import {
    BASE,
    URLS,
    APIS,
    SF_BTCH_SCHD_FORM,
    SG_BTCH_SCHD_PRMT_LIST,
} from "@/tra/tancis/ptli/btch/schd/service/PtliBtchSchdMgmtService";
import { cursorTo } from "readline";

/*
 * Manage schedules registration
 * !== 스케줄관리 등록 ==!
 */
export const PTLI1202002S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0047", "auth_ptli0048"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    // Change execution cycle select !== 실행주기 select 변경 ==!
    const [btchCycleTp, setBtchCycleTp] = useState();

    /*
     * Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        grid.btchSchdPrmtList.setOption("checkbox", false);
        grid.btchSchdPrmtList.setOption("index", true);

        // Processing that parameter name cannot be modified !== 파라미터명 수정 불가 처리 ==!
        grid.btchSchdPrmtList.setEdit("column", "btchPrmtNm", false);
    }, []);

    /* Batch Execution Time !== 시간 ==!*/
    const excutnSchdTime = [
        { label: "00", value: "00" },
        { label: "01", value: "01" },
        { label: "02", value: "02" },
        { label: "03", value: "03" },
        { label: "05", value: "05" },
        { label: "06", value: "07" },
        { label: "08", value: "08" },
        { label: "09", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
        { label: "16", value: "16" },
        { label: "17", value: "17" },
        { label: "18", value: "18" },
        { label: "19", value: "19" },
        { label: "20", value: "20" },
        { label: "21", value: "21" },
        { label: "22", value: "22" },
        { label: "23", value: "23" },
        { label: "24", value: "24" },
    ];

    /* Batch Execution Minit !== 분 ==!*/
    const excutnSchdMi = [
        { label: "00", value: "00" },
        { label: "10", value: "10" },
        { label: "20", value: "20" },
        { label: "30", value: "30" },
        { label: "40", value: "40" },
        { label: "50", value: "50" },
    ];

    /* Batch Execution Second !== 초 ==!*/
    const excutnSchdSs = [
        { label: "00", value: "00" },
        { label: "05", value: "05" },
        { label: "10", value: "10" },
        { label: "15", value: "15" },
        { label: "20", value: "20" },
        { label: "25", value: "25" },
        { label: "30", value: "30" },
        { label: "35", value: "35" },
        { label: "40", value: "40" },
        { label: "45", value: "45" },
        { label: "50", value: "50" },
        { label: "55", value: "55" },
    ];

    /* Batch Execution Day of Week !== 요일 ==!*/
    const btchExcutnDwk = [
        { label: "L_SUN", value: "SUN" },
        { label: "L_MON", value: "MON" },
        { label: "L_TUE", value: "TUE" },
        { label: "L_WED", value: "WED" },
        { label: "L_THU", value: "THU" },
        { label: "L_FRI", value: "FRI" },
        { label: "L_SAT", value: "SAT" },
    ];

    /* Batch Execution Day of Week !== 요일 ==!*/
    const excutnCycleCd = [
        { label: "L_EVERYDAY", value: "A" },
        { label: "L_EVERY_WEEK", value: "B" },
        { label: "L_MONTHLY", value: "C" },
        { label: "L_EVERY_YEAR", value: "D" },
        { label: "L_PERIODIC", value: "E" },
    ];

    /* Batch Execution Day !== 일 ==!*/
    const btchExcutnDay = [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
        { label: "16", value: "16" },
        { label: "17", value: "17" },
        { label: "18", value: "18" },
        { label: "19", value: "19" },
        { label: "20", value: "20" },
        { label: "21", value: "21" },
        { label: "22", value: "22" },
        { label: "23", value: "23" },
        { label: "24", value: "24" },
        { label: "25", value: "25" },
        { label: "26", value: "26" },
        { label: "27", value: "27" },
        { label: "28", value: "28" },
        { label: "29", value: "29" },
        { label: "30", value: "30" },
        { label: "31", value: "31" },
    ];

    /* Batch Execution Month !== 월 ==!*/
    const btchExcutnMm = [
        { label: "1", value: "01" },
        { label: "2", value: "02" },
        { label: "3", value: "03" },
        { label: "4", value: "04" },
        { label: "5", value: "05" },
        { label: "6", value: "06" },
        { label: "7", value: "07" },
        { label: "8", value: "08" },
        { label: "9", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
    ];

    /* Batch Execution Time Minute Second !== 시간 분 초 ==!*/
    const btchExcutnTms = [
        { label: "L_HOUR", value: "T" },
        { label: "L_MI", value: "M" },
        { label: "L_SS", value: "S" },
    ];

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Manage schedules Form !== 스케줄관리 Form ==!
        schdInfoForm: useForm({
            defaultSchema: SF_BTCH_SCHD_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        btchSchdPrmtList: useGrid({
            defaultSchema: SG_BTCH_SCHD_PRMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        insertBtchInfo: useFetch({
            api: (data: any) => APIS.insertBtchInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(URLS.ptli1202001q);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),

        getSchdPrmtList: useFetch({
            api: (btchId) => APIS.getSchdPrmtList(btchId),
            onSuccess: (data: any) => {
                const btchPrmtList = data.btchPrmtList.content;

                /**
                 * Setting the parameter list corresponding to the batch ID
                 * !== 배치ID에 해당하는 파라미터 목록 세팅 ==!
                 */
                if (comnUtils.isEmpty(btchPrmtList)) {
                    grid.btchSchdPrmtList.clearData();
                } else {
                    btchPrmtList.forEach((item: any) => {
                        grid.btchSchdPrmtList.addRow({ ...item });
                    });
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.schdInfoForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.schdInfoForm.handleSubmit(
                () => {
                    const data = form.schdInfoForm.getValues();

                    if (data.excutnCycle == "B") {
                        const arrDay = [0, 0, 0, 0, 0, 0, 0];

                        for (let i = 0; i < data.btchExcutnDwk.length; i++) {
                            if (data.btchExcutnDwk[i] == "SUN") {
                                arrDay[0] = 1;
                            } else if (data.btchExcutnDwk[i] == "MON") {
                                arrDay[1] = 1;
                            } else if (data.btchExcutnDwk[i] == "TUE") {
                                arrDay[2] = 1;
                            } else if (data.btchExcutnDwk[i] == "WED") {
                                arrDay[3] = 1;
                            } else if (data.btchExcutnDwk[i] == "THU") {
                                arrDay[4] = 1;
                            } else if (data.btchExcutnDwk[i] == "FRI") {
                                arrDay[5] = 1;
                            } else if (data.btchExcutnDwk[i] == "SAT") {
                                arrDay[6] = 1;
                            }
                        }

                        data.excutnSchdDd = arrDay.join().replaceAll(",", "");
                    } else if (data.excutnCycle == "C") {
                        data.excutnSchdDd = "000000" + data.btchExcutnDay;
                    } else if (data.excutnCycle == "D") {
                        data.excutnSchdDd = "0000" + data.btchExcutnMm + data.btchExcutnDay;
                    } else if (data.excutnCycle == "E") {
                        if (data.btchExcutnTms == "T") {
                            data.excutnSchdTime = data.btchSchdTmsValue;
                            data.excutnSchdMi = null;
                            data.excutnSchdSs = null;
                        }

                        if (data.btchExcutnTms == "M") {
                            data.excutnSchdTime = null;
                            data.excutnSchdMi = data.btchSchdTmsValue;
                            data.excutnSchdSs = null;
                        }

                        if (data.btchExcutnTms == "S") {
                            data.excutnSchdTime = null;
                            data.excutnSchdMi = null;
                            data.excutnSchdSs = data.btchSchdTmsValue;
                        }
                    }

                    data.schdPrmtList = grid.btchSchdPrmtList.getData();

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.insertBtchInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },

        onCloseBtchModal: (btchId: string) => {
            if (comnUtils.isEmpty(btchId)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            /* Schedule parameter grid initialization !== 스케줄 파라미터 그리드 초기화 ==! */
            grid.btchSchdPrmtList.clearData();

            fetch.getSchdPrmtList.fetch(btchId);
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_btchSchdSrchList: {},
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.schdInfoForm.schema.btchId}
                                controlSize={10}
                                rightButton={{
                                    icon: "search",
                                    onClick: () => {
                                        const handlePopup = (data: any) => {
                                            // Check the data received in the modal window !== Modal 창에서 받은 데이터 확인 ==!
                                            form.schdInfoForm.setValue("btchId", data.btchId);
                                            form.schdInfoForm.setValue("btchNm", data.btchNm);

                                            handler.onCloseBtchModal(data.btchId);

                                            modal.closeModal();
                                        };

                                        modal.openModal({
                                            content: <PTLI1201001Q handlePopup={handlePopup} />,
                                            size: "md",
                                            draggable: true,
                                        });
                                    },
                                }}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.schdInfoForm.schema.btchNm} controlSize={10} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.schdInfoForm.schema.btchSchdNm} controlSize={10} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Label label={"L_EXCUTN_CYCLE"} required={true} />
                            <Group.Col padding={1} colSize={2}>
                                <FormControl
                                    {...form.schdInfoForm.schema.excutnCycle}
                                    options={excutnCycleCd}
                                    onChange={(value) => {
                                        form.schdInfoForm.clearErrors();
                                        setBtchCycleTp(value);
                                    }}
                                />
                            </Group.Col>

                            {btchCycleTp == "A" && (
                                <Group.Col padding={1} colSize={8}>
                                    <Group.Label label={"L_HOUR"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdTime}
                                        options={excutnSchdTime}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_MI"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdMi}
                                        options={excutnSchdMi}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_SS"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdSs}
                                        options={excutnSchdSs}
                                        size={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}

                            {btchCycleTp == "B" && (
                                <Group.Col padding={1} colSize={8}>
                                    <FormControl
                                        {...form.schdInfoForm.schema.btchExcutnDwk}
                                        options={btchExcutnDwk}
                                        size={6}
                                        required={true}
                                    />
                                    <Group.Label label={"L_HOUR"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdTime}
                                        options={excutnSchdTime}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_MI"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdMi}
                                        options={excutnSchdMi}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_SS"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdSs}
                                        options={excutnSchdSs}
                                        size={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}

                            {btchCycleTp == "C" && (
                                <Group.Col padding={1} colSize={8}>
                                    <Group.Label label={"L_DD"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.btchExcutnDay}
                                        options={btchExcutnDay}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_HOUR"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdTime}
                                        options={excutnSchdTime}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_MI"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdMi}
                                        options={excutnSchdMi}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_SS"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdSs}
                                        options={excutnSchdSs}
                                        size={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}

                            {btchCycleTp == "D" && (
                                <Group.Col padding={1} colSize={8}>
                                    <Group.Label label={"L_MM"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.btchExcutnMm}
                                        options={btchExcutnMm}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_DD"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.btchExcutnDay}
                                        options={btchExcutnDay}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_HOUR"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdTime}
                                        options={excutnSchdTime}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_MI"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdMi}
                                        options={excutnSchdMi}
                                        size={2}
                                        required={true}
                                    />
                                    <Group.Label label={"L_SS"} />
                                    <FormControl
                                        {...form.schdInfoForm.schema.excutnSchdSs}
                                        options={excutnSchdSs}
                                        size={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}

                            {btchCycleTp == "E" && (
                                <Group.Col padding={1} colSize={8}>
                                    <FormControl
                                        {...form.schdInfoForm.schema.btchExcutnTms}
                                        options={btchExcutnTms}
                                        size={2}
                                        required={true}
                                    />
                                    <FormControl
                                        {...form.schdInfoForm.schema.btchSchdTmsValue}
                                        size={2}
                                        maxLength={2}
                                        required={true}
                                    />
                                </Group.Col>
                            )}
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_SCHD_PRMT_LIST"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Grid {...grid.btchSchdPrmtList.grid} render={render.grid_btchSchdSrchList} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli1202001q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};

/*
 * Batch information list Modal
 * !== 배치정보 목록 Modal ==!
 */
export const PTLI1201001Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "bsopClsfCd" }, { area: "comnCd", comnCd: "COM0024" }],
    });

    const { data, handlePopup } = props;

    const { pgeUid } = usePage({ pgeUid: "ptli1201001q" });
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const BASE = {
        path: `${ptlEnvs.base}/btch/info`,
        api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/btch/infos`,
        nodes: [],
    };

    const APIS = {
        // Get a list of batch information. !== 배치정보 목록을 조회한다. ==!
        getBtchInfoList: (data: any, page: number, size: number) => {
            return api.get(`${BASE.api}?page=${page}&size=${size}`, {
                params: comnUtils.toGetParams(data),
            });
        },
    };

    // 현재 화면설계 참고 -> 항목과 검색어 입력폼 명은 개발에 맞게 변경 해주세요(현재는 라벨이없어서 임시로 넣어놓았습니다)
    const SG_FORM: TFormSchema = {
        id: "form",
        schema: {
            bsopClsfCd: {
                type: "select",
                label: "L_BSOP_CLSF_NM",
                all: true,
                area: "comnCd",
                comnCd: "COM0024",
            },
            /* Search keyword Select Option !== 검색어 목록 ==!*/
            kwdSel: {
                type: "select",
                label: "L_KWD",
                options: [
                    { label: "배치명", value: "A" },
                    { label: "배치설명", value: "B" },
                ],
            },
            /* Search keyword Select Option Name !== 검색어 ==!*/
            kwdTxt: {
                type: "text",
                readOnly: true,
            },
        },
    };

    const SG_BTCH_INFO_LIST: TGridSchema = {
        id: "grid_btchInfoList",
        options: { pagination: "out", index: true },
        head: [
            { cells: [{ header: "L_BTCH_ID", binding: "btchId", width: "*" }], id: "btchId" },
            { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "*" }], id: "bsopClsfCdNm" },
            { cells: [{ header: "L_BTCH_NM", binding: "btchNm", width: "*" }], id: "btchNm" },
            { cells: [{ header: "L_BTCH_DESC", binding: "btchDesc", width: "*" }], id: "btchDesc" },
            {
                cells: [{ header: "L_ONLN_EXCUTN_YN", binding: "onlnExcutnPsblYn", width: 100 }],
                id: "onlnExcutnPsblYn",
            },
        ],
        body: [
            {
                cells: [{ binding: "btchId" }] /* Batch ID !== 배치 ID ==!*/,
            },
            {
                cells: [{ binding: "bsopClsfCdNm" }] /* Business Type !== 업무분류 ==!*/,
            },
            {
                cells: [{ binding: "btchNm", align: "left" }] /* Job Name(Barch Name) !== Job 이름(배치명) ==!*/,
            },
            {
                cells: [{ binding: "btchDesc", align: "left" }] /* Batch Description !== 배치설명 ==!*/,
            },
            {
                cells: [{ binding: "onlnExcutnPsblYn" }] /* Online Execution Yn !== 온라인 실행여부 ==!*/,
            },
        ],
    };

    const form = useForm({
        defaultSchema: SG_FORM,
        defaultValues: { ...data },
    });

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        btchInfoList: useGrid({
            defaultSchema: SG_BTCH_INFO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_btchInfoSrchList: {
            cell: {
                onlnExcutnPsblYn: (props: any) => {
                    const { value } = props;
                    return value === "Y" ? "Yes" : "No";
                },
                btchNm: (props: any) => {
                    const { value } = props;
                    return <a style={{ cursor: "pointer" }}>{value}</a>;
                },
            },
        },
    };

    const handler = {
        getBtchInfoList: (page: number = 0) => {
            form.handleSubmit(
                () => {
                    grid.btchInfoList.setPage(page);
                    fetch.getBtchInfoList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        onGridCellClick: (cell: any) => {
            const { binding, rowValues } = cell;

            if (binding === "btchNm") {
                handlePopup(rowValues);
            }
        },
    };

    const fetch = {
        // Get a list of batch information. !== 배치정보 목록을 조회한다. ==!
        getBtchInfoList: useFetch({
            api: (page = grid.btchInfoList.page) =>
                APIS.getBtchInfoList(form.getValues(), page, grid.btchInfoList.size),
            enabled: comnUtils.isEmpty(form.errors),
            key: [grid.btchInfoList.page, grid.btchInfoList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.getValues(),
                    page: grid.btchInfoList.page,
                    size: grid.btchInfoList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
    };

    const kwdSel = form.watch("kwdSel");

    return (
        <>
            <Page pgeUid={pgeUid} info={true}>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.schema.bsopClsfCd} />
                                <Group.Label label={"L_KWD"} />
                                <Group.Col padding={1}>
                                    <Layout direction="row" gap={1}>
                                        <FormControl {...form.schema.kwdSel} />
                                        <FormControl {...form.schema.kwdTxt} readOnly={!kwdSel} />
                                    </Layout>
                                </Group.Col>
                            </Group.Row>
                        </Group.Section>

                        <Layout direction="row">
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getBtchInfoList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>

                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Grid
                                {...grid.btchInfoList.grid}
                                data={fetch.getBtchInfoList.data?.btchInfoList}
                                onCellClick={handler.onGridCellClick}
                                render={render.grid_btchInfoSrchList}
                            />
                        </Group.Section>
                    </Group.Body>
                </Group>
            </Page>
        </>
    );
};
